import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLauch = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "m9.3333 1.3333h-5.3333c-.70724 0-1.3855.28095-1.8856.78105-.50011.50009-.78105 1.1784-.78105 1.8856v16c0 .7072.28095 1.3855.78105 1.8856.50009.50013 1.1784.78107 1.8856.78107h16c.7072 0 1.3855-.28093 1.8856-.78107s.78107-1.1784.78107-1.8856v-5.3333m-10.667-2.6667 10.667-10.667m0 0v6.6667m0-6.6667h-6.6667",
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 2.6667
	})]
});
const ForwardRef = forwardRef(SvgLauch);
export { ForwardRef as ReactComponent };
